import Modals from '../blocks/modals.js'
import modals from "./modals.js";

class Events {
  constructor () {
    this.init()
  }

  init () {
    const $eventRegistration = $('.inscription-button a')
    if ($eventRegistration.length) {
      $eventRegistration.on('click', function () {
        const idHubspotEvent = $('#id-hubspot').data('idHubspot')
        const modal = new Modals()
        modal.openModal('event-registration', idHubspotEvent)
        hbspt.forms.create({
          region: 'eu1',
          portalId: '25386520',
          formId: idHubspotEvent,
          target: '#hubspot-form-container',
          onFormReady: function() {
            const email = $('#id-hubspot').data('email')
            if (email) {
              const emailField = $('#hubspot-form-container').find('input[name="email"]')
              if (emailField && $('#id-hubspot').data('email')) {
                emailField.val($('#id-hubspot').data('email')).change()
              }

              const firstnameField = $('#hubspot-form-container').find('input[name="firstname"]')
              if (firstnameField && $('#id-hubspot').data('firstname')) {
                firstnameField.val($('#id-hubspot').data('firstname')).change()
              }

              const lastnameField = $('#hubspot-form-container').find('input[name="lastname"]')
              if (lastnameField && $('#id-hubspot').data('lastname')) {
                lastnameField.val($('#id-hubspot').data('lastname')).change()
              }
            }
          },
          onFormSubmit: function ($form) {
            $('#event-registration #hubspot-form-container').hide()
            $('#event-registration .waiting').show()
            $.ajax({
              method: 'POST',
              url: sage.ajax_url,
              data: { post_id: $('#id-hubspot').data('event-id'), action: 'event_registration_confirmation' }
            })
                .done(result => {
                  $('#event-registration').hide()
                  modal.openModal('remerciement-registration')

                  $eventRegistration.addClass('disabled')
                  $eventRegistration.find('.x-button-link-label').text('Vous êtes inscrit à cet évènement')
                  $('.url-teams').removeClass('hide')
                })
          }
        })
      })
    }
  }
}
export default Events
